import { useMemo, useState, useEffect } from "react";
import { motion } from "framer-motion";
import clsx from "clsx";
import { useMediaQuery } from "react-responsive";
import { logoOxoneBlack, iconSearch } from "../../assets/images";
import { mediaQueries } from "../../constant";
import styles from "./styles.module.scss";

function Header() {
  const [isOpenNav, setIsOpenNav] = useState(false);

  const dataNav = useMemo(
    () => [
      { title: "Beranda", internal: false, url: "https://oxone-online.com/" },
      { title: "Tentang Kami", internal: true },
      {
        title: "Kategori",
        internal: false,
        url: "https://oxone-online.com/produk-kami/",
      },
      {
        title: "Jurnal",
        internal: false,
        url: "https://oxone-online.com/jurnal/",
      },
      {
        title: "Hubungi Kami",
        internal: false,
        url: "https://oxone-online.com/hubungi-kami/",
      },
    ],
    []
  );
  const variantContainer = useMemo(
    () => ({
      offScreen: { y: -50, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 0.5,
        },
      },
    }),
    []
  );

  useEffect(() => {
    let body = document.body || document.getElementsByTagName("body")[0];
    if (isOpenNav) body.classList.add("overflow-hidden");
    else body.classList.remove("overflow-hidden");
  }, [isOpenNav]);

  const isBiggerScreen = useMediaQuery({
    query: `(min-device-width: ${mediaQueries?.miniDesktop}px)`,
  });

  useEffect(() => {
    setIsOpenNav(false);
  }, [isBiggerScreen]);

  return (
    <header
      className={clsx(
        "absolute lg:relative top-0 left-0 right-0 lg:top-auto lg:left-auto lg:right-auto z-20",
        styles.header
      )}
    >
      <motion.div
        variants={variantContainer}
        initial="offScreen"
        whileInView="onScreen"
        // viewport={{ once: true }}
        className={clsx(
          "flex items-center justify-between overflow-x-hidden",
          styles.container,
          {
            [styles.showNav]: isOpenNav,
          }
        )}
      >
        <div
          className={clsx(
            "p-1 lg:hidden relative cursor-pointer z-30",
            styles.burgerContainer,
            {
              [styles.showNav]: isOpenNav,
            }
          )}
          onClick={() => setIsOpenNav(!isOpenNav)}
        >
          <span className="relative block w-5" />
        </div>

        <div className="relative z-30">
          <a href="https://oxone-online.com/">
            <img
              src={logoOxoneBlack}
              alt="logo-oxone"
              height={isBiggerScreen ? 32 : 40}
            />
          </a>
        </div>
        <nav
          className={clsx("absolute lg:relative", styles.navContainer, {
            "top-0 left-0 right-0 lg:top-auto lg:left-auto lg:right-auto lg:relative px-4 lg:px-0":
              isOpenNav,
            [styles.showNav]: isOpenNav,
          })}
        >
          <ul
            className={clsx("flex flex-col lg:flex-row lg:items-center", {
              "border-t lg:border-0": isOpenNav,
            })}
          >
            {dataNav?.map((item, index) => (
              <li
                key={index}
                className={clsx({
                  "lg:ml-4": index !== 0,
                  "py-4 lg:py-0": isOpenNav,
                })}
              >
                <a href={item?.url || undefined} className="cursor-pointer p-2">
                  {item?.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="relative z-30">
          {/* <Image src={iconSearch} alt="icon-search" width={20} height={20} /> */}
        </div>
      </motion.div>
    </header>
  );
}

export default Header;
